import { render, staticRenderFns } from "./OrdersBlock.vue?vue&type=template&id=641e0093&scoped=true&"
import script from "./OrdersBlock.vue?vue&type=script&lang=js&"
export * from "./OrdersBlock.vue?vue&type=script&lang=js&"
import style0 from "./OrdersBlock.vue?vue&type=style&index=0&id=641e0093&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641e0093",
  null
  
)

export default component.exports